<script setup lang="ts">
  // 講座未入会時に表示するダイアログ。モーダルではない
  import { useLoginStore } from "~/stores/LoginStore";
  import { useHistoryStore } from "~/stores/HistoryStore";

  const loginStore = useLoginStore();
  const historyStore = useHistoryStore();

  interface Props {
    planId: string;
    planTitle: string;
    contentType: string;
    openWindow?: boolean;
  }
  const props = defineProps<Props>();

  defineEmits(["click-bg"]);

  const message = `${props.planTitle}に入会して\n${props.contentType}を見よう`;

  const click = () => {
    if (props.openWindow) {
      window.open(`/plan/${props.planId}?tab=overview`);
    } else {
      historyStore.to({
        path: `/plan/${props.planId}`,
        query: { tab: "overview" },
      });
    }
  };
  const loginLink = computed<string>(() => {
    if (props.openWindow) {
      return `/login?returnPath=/plan/${props.planId}?tab=overview`;
    } else {
      return `/login?returnPath=${encodeURIComponent(useRoute().fullPath)}`;
    }
  });

  // レスポンシブ対応
  const isSp = isSpDisplayRef();
  const fontSize = computed<string>(() => (isSp.value ? "16px" : "18px"));
  const lineHeight = computed<string>(() => (isSp.value ? "22px" : "26px"));
</script>

<template>
  <Transition name="fade">
    <v-sheet class="w-100 h-100 dialog-bg" color="rgba(0,0,0,0.6)" @click.stop="$emit('click-bg')">
      <v-sheet class="dialog py-8 px-10 rounded" align="center">
        <div class="text-center">{{ message }}</div>

        <v-btn color="main-01" class="mt-5 px-2 button" @click.stop="click"> 講座の紹介を見る </v-btn>
        <div v-if="!loginStore.isLogin()">
          <div class="no-login-border"></div>
          <div>講座入会済みの方は<br />ログインの上ご覧ください</div>
          <div class="login-link-wrapper">
            <NuxtLink v-if="openWindow" class="login-link" :to="loginLink" target="_blank"
              >アカウントにログイン</NuxtLink
            >
            <NuxtLink v-else class="login-link" :to="loginLink">アカウントにログイン</NuxtLink>
          </div>
        </div>
      </v-sheet>
    </v-sheet>
  </Transition>
</template>

<style lang="scss" scoped>
  @import "assets/media.scss";
  .dialog-bg {
    z-index: 2;
    position: absolute;
    top: 0;
  }

  .dialog {
    background-color: rgba(var(--v-theme-monochrome-04), 0.85);
    min-height: 146px;
    min-width: 345px;
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);

    font-size: v-bind(fontSize);
    line-height: v-bind(lineHeight);
    white-space: break-spaces;
  }
  .button {
    min-width: 125px;
    min-height: 40px;
    margin-left: 4px;
    margin-right: 4px;

    font-size: v-bind(fontSize);
    font-weight: 700;
    line-height: v-bind(lineHeight);
  }

  .no-login-border {
    margin: 20px 0;
    background-color: #ffffff;
    opacity: 0.1;
    height: 1px;
  }

  .login-link-wrapper {
    margin-top: 20px;
  }

  .login-link {
    text-decoration: none;
    font-size: v-bind(fontSize);
    font-weight: 700;
    line-height: v-bind(lineHeight);
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s ease;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
</style>
